"use client";

import React, { ReactNode } from "react";
import NextLink from "next/link";
import { Badge, BadgeProps, Box, Button, Icon, styled, Typography } from "@mui/material";
const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    // bottom: -3,
    border: `1px solid ${theme.palette.background.paper}`,
    padding: "4px",
    minWidth: "auto",
    color: "white",
    borderRadius: 2,
    // left: "50%",
    height: "14px",
  },
}));

export default function BottomButton({
  selected,
  label,
  boldIcon,
  icon,
  badge,
  href,
  onClick,
  className,
}: {
  selected?: boolean;
  label: string;
  badge?: number;
  icon: ReactNode;
  boldIcon: ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
}) {
  const hasBadge = Boolean(badge);
  const link = href ? { href: href, component: NextLink } : {};
  return (
    <Button
      {...link}
      className={className}
      // variant={selected ? "contained" : "text"}
      disableElevation
      disableRipple
      sx={{
        borderRadius: 100,
        height: "100%",
        transition: "all 0.2s ease",
        color: "white.main",
        position: "relative",
      }}
      onClick={() => {
        onClick && onClick();
      }}
    >
      <Box
        sx={{
          px: 1,
          py: 0.5,
          display: "flex",
          alignItems: "center",
          gap: 0.7,
          borderRadius: 100,
          backgroundColor: selected ? "white.main" : "transparent",
          color: selected ? "grey.800" : "inherit",
        }}
      >
        <StyledBadge
          invisible={!hasBadge}
          badgeContent={badge}
          max={99}
          color="secondary"
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Icon fontSize="small" sx={{ mt: 0, transition: "all 0.2s ease" }}>
            {selected ? boldIcon : icon}
          </Icon>
        </StyledBadge>

        <Typography variant="button" noWrap sx={{ m: 0 }}>
          {label}
        </Typography>
      </Box>
    </Button>
  );
}
